import React from "react";
import { StatusPill } from "./ui.jsx";

export function OrbitBoard({ label = "Simplified heliocentric orbit chart" }) {
  return (
    <div className="orbit-board" aria-label={label}>
      <div className="orbit-sun" />
      <div className="orbit-track orbit-mercury" />
      <div className="orbit-track orbit-venus" />
      <div className="orbit-track orbit-earth" />
      <div className="planet planet-mercury" />
      <div className="planet planet-venus" />
      <div className="planet planet-earth" />
      <span className="line-of-sight" />
      <span className="interference-cone" />
    </div>
  );
}

export function TimelineChart({ rows }) {
  return (
    <div className="timeline">
      {rows.map((row) => (
        <div className="timeline-row" key={row.label}>
          <span>{row.label}</span>
          {row.lanes.map((lane, index) => (
            <span className={`lane ${lane}`} key={`${row.label}-${lane}-${index}`} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function ProcessFlowChart({ steps }) {
  return (
    <div className="process-flow">
      {steps.map((step, index) => (
        <span key={step}>
          {index + 1}. {step}
        </span>
      ))}
    </div>
  );
}

export function BodyFitGrid({ rows }) {
  return (
    <div className="fit-grid">
      {rows.map((fit) => (
        <div key={fit.body} className="fit-card">
          <span>{fit.body}</span>
          <strong>{fit.score}</strong>
          <StatusPill tone={fit.confidence === "high" ? "green" : fit.confidence === "medium" ? "amber" : "red"}>
            {fit.confidence}
          </StatusPill>
        </div>
      ))}
    </div>
  );
}
